export const handleModalClose = (event, reason, handleClose) => {
    // Prevent closing on ESC key press or backdrop click
    if (reason === 'backdropClick' || reason === 'escapeKeyDown') {
        return;
    }
    // Call original handleClose for other cases
    handleClose();
};
